import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'distance',
  standalone: false
})
export class DistancePipe implements PipeTransform {
  transform(value: number, unit?: 'm' | 'km'): string {
    if (!value || typeof value !== 'number') {
      return '';
    }

    let distance = value;

    if (unit === 'm') {
      distance = distance / 1000;
    }

    let result: string;

    if (value < 1) {
      result = `${Math.round(distance * 1000)} m`;
    } else {
      result = `${Math.round(distance * 100) / 100} km`;
    }

    return result;
  }
}
